import { SET_ERROR } from "../constants";
import { qualifySelector } from "../utils";

const initialState = {
  error: false,
};

function reducer(state = initialState, action) {
  const { payload } = action;

  switch (action.type) {
    case SET_ERROR:
      return {
        error: payload,
      };
    default:
      return state;
  }
}

export const name = "ui";
export default { [name]: reducer };

export const getError = qualifySelector(name, (state) => state.error);
